function UpdatePassword() {
  return <>Update Password</>;
}
export default UpdatePassword;
